<div class="flex flex-col">

  <!-- Kopf. Steht fest, scrollt nicht mit. Das Zahnrad sitzt hier und nicht in der Filterzeile
       darunter, wie auf der Seite /notifications auch. -->
  <div class="flex flex-row items-center justify-between gap-2 mb-2">
    <div class="text-lg font-medium">{{'notificationCenterComponent.headline' | translate}}</div>
    <nx-default-button
      [style]="'light'"
      [icon]="'icon-settings'"
      [tooltip]="'notificationCenterComponent.settings' | translate"
      (click)="goToSettings(); $event.stopPropagation()">
    </nx-default-button>
  </div>

  <!-- Filterzeile: die zwei Segmente links, "Alle als gelesen markieren" rechts (Vorbild App).
       `accent` ist das vorhandene #DAFF00 aus ng-theme.scss — frueher stand dafuer ein
       ::ng-deep-Block in einer eigenen .scss, der 'dark' von Hand umfaerbte.
       Der aktive Knopf ist NICHT disabled: das dimmte ihn, und genau dieses Dimmen musste die
       alte Stilregel wieder zuruecknehmen. Den Klick faengt setSegment() ab.
       flex-wrap, weil "Alle als gelesen markieren" in anderen Sprachen laenger wird. -->
  <div class="flex flex-row flex-wrap items-center gap-2 mb-2">
    <nx-default-button
      [style]="list.segment() === 'unread' ? 'accent' : 'dark'"
      (click)="setSegment('unread'); $event.stopPropagation()"
      [label]="'notificationCenterComponent.tabs.unread'">
    </nx-default-button>
    <nx-default-button
      [style]="list.segment() === 'all' ? 'accent' : 'dark'"
      (click)="setSegment('all'); $event.stopPropagation()"
      [label]="'notificationCenterComponent.tabs.all'">
    </nx-default-button>
    <div class="flex-1"></div>
    <!-- Immer sichtbar, nur deaktiviert: mit *ngIf sprang die Zeile, sobald die letzte Zeile
         gelesen wurde. -->
    <nx-default-button
      [style]="'dark'"
      [disabled]="unreadCount() === 0"
      (click)="markAllAsRead(); $event.stopPropagation()"
      [label]="'notificationCenterComponent.markAllAsRead'">
    </nx-default-button>
  </div>

  <!-- Der Scroll-Container liegt hier und nicht am p-overlayPanel: der Observer des Infinite
       Scroll braucht ihn als `root`, und Kopf und Filterzeile sollen stehenbleiben. -->
  <div #scrollBox data-testid="scroll-box" class="overflow-y-auto max-h-[65vh]">

    <!-- Pruefreihenfolge wie ReactiveContainer-Vorbild (notification-settings-list): error() VOR
         loading() — hier zwar zwei eigenstaendige Signale statt einem gemeinsamen Container, die
         Reihenfolge ist aber genauso verbindlich, falls beide je einmal gleichzeitig wahr waeren. -->
    <div *ngIf="list.error()" class="bg-white px-5 py-4 text-[#c0123c]">
      {{ 'notificationCenterComponent.loadErrorMessage' | translate }}
    </div>
    <div *ngIf="!list.error() && list.loading()" class="flex flex-row justify-center py-4">
      <p-progressSpinner [style]="{width: '2rem', height: '2rem'}" strokeWidth="4"></p-progressSpinner>
    </div>

    <ng-container *ngIf="!list.error() && !list.loading()">

      <!-- Eine Gruppe je Kalendertag. Der Kopf klebt oben, solange seine Gruppe im Bild ist.
           Der Wrapper-<div> ist noetig, damit `last:border-none` je Gruppe greift und nicht
           quer ueber alle Zeilen. -->
      <div *ngFor="let group of groups()">
        <div class="sticky top-0 z-10 bg-white py-1 text-[12px] font-medium uppercase tracking-wider text-[#848488]">
          <!-- Locale fest 'de': die App setzt keinen globalen LOCALE_ID, ohne das dritte Argument
               stuenden hier englische Wochentage. Dieselbe Festlegung wie bei der Relativzeit
               (core/pipes/relative-time.pipe.ts), die ebenfalls deutsch ist. -->
          {{ group.labelKey
              ? (group.labelKey | translate)
              : (group.labelDate | date: 'EEEE, dd.MM.' : undefined : 'de') }}
        </div>
        <app-notification
          *ngFor="let notification of group.items"
          class="block border-b border-gray last:border-none"
          [notification]="notification"
          [list]="list"
          (navigated)="navigated.emit()">
        </app-notification>
      </div>

      <nx-empty-box
        *ngIf="list.items().length === 0"
        [label]="emptyStateKey()">
      </nx-empty-box>

      <!-- Sentinel des Infinite Scroll. Sichtbar genau dann, wenn es noch etwas zu holen gibt —
           der Spinner ist damit zugleich die Zusage "da kommt noch was". -->
      <div #sentinel data-testid="scroll-sentinel" *ngIf="list.hasMore()"
           class="flex flex-row justify-center py-3">
        <p-progressSpinner [style]="{width: '1.5rem', height: '1.5rem'}" strokeWidth="4"></p-progressSpinner>
      </div>

    </ng-container>
  </div>
</div>
